import React from "react";

import ChecklistRunner from "../base/ChecklistRunner";

import { sendingEmailsChecklistConfiguration } from "./configuration";

const SendingEmailsChecklist = () => {
  return <ChecklistRunner descriptor={sendingEmailsChecklistConfiguration} />;
};

export default SendingEmailsChecklist;
